import { render } from "./AppRatesCard.vue?vue&type=template&id=7775d376"
import script from "./AppRatesCard.vue?vue&type=script&lang=js"
export * from "./AppRatesCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__